import { useState, type FormEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { acesso } from '../api/acesso'
import { Aviso } from '../componentes/Aviso'
import { Botao } from '../componentes/Botao'
import { Campo } from '../componentes/Campo'
import { mensagemDeErro } from './mensagemDeErro'
import './acesso.css'

/** Mesmo mínimo do servidor. Aqui é aviso; lá é regra. */
const MINIMO = 12

/**
 * Define a senha a partir do link do e-mail — serve ao convite e à recuperação.
 *
 * A validação daqui é cortesia: ela evita a viagem até o servidor para dizer o
 * óbvio. Quem decide se a senha vale é o back, sempre.
 */
export function DefinirSenha({ convite }: { convite: boolean }) {
  const { t } = useTranslation()

  const token = new URLSearchParams(window.location.search).get('t') ?? ''

  const [senha, setSenha] = useState('')
  const [repetida, setRepetida] = useState('')
  const [pronto, setPronto] = useState(false)
  const [erro, setErro] = useState<string | null>(null)
  const [enviando, setEnviando] = useState(false)

  const curta = senha.length > 0 && senha.length < MINIMO
  const diferente = repetida.length > 0 && senha !== repetida

  async function definir(evento: FormEvent) {
    evento.preventDefault()
    if (curta || diferente || !senha) return

    setErro(null)
    setEnviando(true)

    try {
      await acesso.definirSenha(token, senha)
      setPronto(true)
    } catch (e) {
      setErro(mensagemDeErro(e, t))
    } finally {
      setEnviando(false)
    }
  }

  if (!token)
    return (
      <main className="acesso">
        <div className="acesso__cartao">
          <h1 className="acesso__titulo">{t('definirSenha.titulo')}</h1>
          <Aviso tom="perigo">{t('definirSenha.semToken')}</Aviso>
        </div>
      </main>
    )

  return (
    <main className="acesso">
      <div className="acesso__cartao">
        <h1 className="acesso__titulo">
          {convite ? t('definirSenha.tituloConvite') : t('definirSenha.titulo')}
        </h1>

        {pronto ? (
          <>
            <Aviso tom="sucesso">{t('definirSenha.pronto')}</Aviso>
            <div className="acesso__acoes">
              <Botao variante="primario" onClick={() => (window.location.href = '/')}>
                {t('definirSenha.entrarAgora')}
              </Botao>
            </div>
          </>
        ) : (
          <form onSubmit={definir} noValidate>
            <p className="acesso__descricao">
              {convite ? t('definirSenha.descricaoConvite') : t('definirSenha.descricao')}
            </p>

            {erro && <Aviso tom="perigo">{erro}</Aviso>}

            <Campo
              rotulo={t('definirSenha.nova')}
              type="password"
              name="nova"
              autoComplete="new-password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              ajuda={t('definirSenha.minimo', { minimo: MINIMO })}
              erro={curta ? t('definirSenha.curta', { minimo: MINIMO }) : undefined}
              obrigatorio
              autoFocus
            />

            <Campo
              rotulo={t('definirSenha.repetir')}
              type="password"
              name="repetir"
              autoComplete="new-password"
              value={repetida}
              onChange={(e) => setRepetida(e.target.value)}
              erro={diferente ? t('definirSenha.diferente') : undefined}
              obrigatorio
            />

            <div className="acesso__acoes">
              <Botao
                type="submit"
                variante="primario"
                carregando={enviando}
                disabled={!senha || curta || diferente}
              >
                {t('definirSenha.salvar')}
              </Botao>
            </div>
          </form>
        )}
      </div>
    </main>
  )
}
